<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100">LINE Rich Menu</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2">
        Member vs Guest — สร้างผ่าน Messaging API แล้วเก็บ id ใน DB
        <span *ngIf="config() as cfg" class="ml-2 font-semibold text-amber-600">
          ({{ cfg.tokenProfile }} · member: {{ cfg.memberRichMenuIdSource || '-' }} · guest: {{ cfg.guestRichMenuIdSource || '-' }})
        </span>
      </p>
    </div>
    <div class="flex gap-3">
      <button type="button" (click)="onRefresh()" class="p-3 bg-white/95 dark:bg-slate-900/95 rounded-2xl border">
        <span class="material-icons">refresh</span>
      </button>
      <button
        *ngIf="canUpdate"
        type="button"
        (click)="onSaveConfig()"
        [disabled]="isSaving() || isLoading()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg disabled:opacity-50"
      >
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก Member/Guest' }}
      </button>
    </div>
  </div>

  <div class="relative space-y-6">
    <app-pss-loading *ngIf="isLoading() || isWorking()"></app-pss-loading>

    <!-- Config -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 p-6 md:p-8">
      <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-4">Config (city_parking_setting)</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">Member RichMenuId</label>
          <input
            [(ngModel)]="memberRichMenuId"
            [disabled]="!canUpdate"
            placeholder="richmenu-xxxx"
            class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
          />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">Guest RichMenuId (optional)</label>
          <input
            [(ngModel)]="guestRichMenuId"
            [disabled]="!canUpdate"
            placeholder="ว่างได้ — Guest ใช้ default จาก OA Manager"
            class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
          />
        </div>
      </div>
      <p class="text-xs text-slate-400 mt-3">
        Guest แนะนำให้ตั้งเป็น default ใน OA Manager แล้วปล่อย Guest id ว่าง — unlink จะกลับ default
      </p>
    </section>

    <!-- List -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 p-6 md:p-8 overflow-x-auto">
      <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-4">
        รายการ Messaging API ({{ items().length }})
      </h2>
      <table class="w-full text-left">
        <thead>
          <tr class="text-xs uppercase text-slate-400 border-b">
            <th class="py-3 pr-3">Name</th>
            <th class="py-3 pr-3">RichMenuId</th>
            <th class="py-3 pr-3">Chat bar</th>
            <th class="py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items()" class="border-b border-slate-100 dark:border-slate-800">
            <td class="py-3 pr-3 font-medium">{{ item.name || '-' }}</td>
            <td class="py-3 pr-3 font-mono text-xs">{{ item.richMenuId }}</td>
            <td class="py-3 pr-3">{{ item.chatBarText || '-' }}</td>
            <td class="py-3 flex flex-wrap gap-2">
              <button type="button" class="px-3 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-xs" (click)="useAsMember(item)">
                ใช้เป็น Member
              </button>
              <button type="button" class="px-3 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-xs" (click)="useAsGuest(item)">
                ใช้เป็น Guest
              </button>
              <button type="button" class="px-3 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-xs" (click)="useForUpload(item)">
                อัปโหลดรูป
              </button>
              <button
                *ngIf="canDelete"
                type="button"
                class="px-3 py-1 rounded-lg bg-rose-50 text-rose-600 text-xs"
                (click)="onDelete(item)"
              >
                ลบ
              </button>
            </td>
          </tr>
          <tr *ngIf="items().length === 0">
            <td colspan="4" class="py-8 text-center text-slate-400">ยังไม่มีเมนูใน Messaging API — สร้างด้านล่าง</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- Create + Upload -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 p-6 md:p-8">
      <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100">สร้างเมนู + อัปโหลดรูป</h2>
        <button type="button" (click)="onLoadTemplate()" class="px-4 py-2 rounded-xl border text-xs font-bold">
          โหลด Template JSON
        </button>
      </div>
      <textarea
        [(ngModel)]="createJson"
        rows="12"
        [disabled]="!canCreate"
        class="w-full px-4 py-3 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700 font-mono text-xs"
        placeholder='{"size":{"width":2500,"height":1686}, ...}'
      ></textarea>
      <div class="flex flex-wrap gap-3 mt-4 items-end">
        <button
          *ngIf="canCreate"
          type="button"
          (click)="onCreate()"
          class="px-5 py-2.5 bg-slate-800 text-white rounded-xl font-bold disabled:opacity-50"
        >
          สร้าง Rich Menu
        </button>
        <div class="flex-1 min-w-[200px]">
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">richMenuId สำหรับอัปโหลดรูป</label>
          <input
            [(ngModel)]="uploadRichMenuId"
            [disabled]="!canUpdate"
            class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700 font-mono text-xs"
          />
        </div>
        <label
          *ngIf="canUpdate"
          class="px-5 py-2.5 bg-amber-400 text-white rounded-xl font-bold cursor-pointer"
        >
          เลือกไฟล์รูป
          <input type="file" accept="image/png,image/jpeg" class="hidden" (change)="onFileSelected($event)" />
        </label>
      </div>
      <p class="text-xs text-slate-400 mt-3">JPEG/PNG ≤ 1MB · ความละเอียดต้องตรง size ใน JSON (เช่น 2500×1686)</p>
    </section>

    <!-- Test user link -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 p-6 md:p-8">
      <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-4">ทดสอบลิงก์ต่อ user</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">LINE uid</label>
          <input
            [(ngModel)]="testUid"
            placeholder="Uxxxxxxxx"
            class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700 font-mono text-xs"
          />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">richMenuId (สำหรับ Link)</label>
          <input
            [(ngModel)]="testRichMenuId"
            placeholder="richmenu-xxxx"
            class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700 font-mono text-xs"
          />
        </div>
      </div>
      <div class="flex flex-wrap gap-2 mt-4">
        <button type="button" class="px-4 py-2 rounded-xl border text-xs font-bold" (click)="onLookupUser()">ดูเมนูปัจจุบัน</button>
        <button *ngIf="canUpdate" type="button" class="px-4 py-2 rounded-xl bg-emerald-500 text-white text-xs font-bold" (click)="onEnsureMember()">
          Ensure Member
        </button>
        <button *ngIf="canUpdate" type="button" class="px-4 py-2 rounded-xl bg-slate-800 text-white text-xs font-bold" (click)="onLink()">
          Link
        </button>
        <button *ngIf="canUpdate" type="button" class="px-4 py-2 rounded-xl bg-rose-500 text-white text-xs font-bold" (click)="onUnlink()">
          Unlink → Guest default
        </button>
      </div>
      <p *ngIf="userRichMenuMessage || userRichMenuId !== null" class="mt-3 text-xs">
        ปัจจุบัน:
        <span class="font-mono font-semibold">{{ userRichMenuId || '(default / none)' }}</span>
        <span class="text-slate-400 ml-2">{{ userRichMenuMessage }}</span>
      </p>
    </section>
  </div>
</div>
